module.exports = __webpack_public_path__ + "static/bridge-871d08912fa8a782dbe1266fbd2591b4.jpg";